import {
    GET_COMMITTEES,
    GET_PARENT_COMMITTEES,
	GET_COMMITTEE_TYPES,
	ADD_COMMITTEE,
	DELETE_COMMITTEE,
	UPDATE_COMMITTEE,
	ADD_COMMITTEE_DOCUMENTS,
	GET_COMMITTEE_DOCUMENTS,
	DELETE_COMMITTEE_DOCUMENT
} from '../../Actions/Admin/ManageCommitteeAction';

const initialState = {
	committees: [],
    committeeTypes: [],
	parentCommittees:[],
	committeeDocuments:[]
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_COMMITTEES:
			return {
				...state,
				committees: action.payload,
				loading: false
			};
		case ADD_COMMITTEE:
			return {
				...state,
				committees: action.payload
			};
		case DELETE_COMMITTEE:
			return {
				...state,
				committees: action.payload
			};
		case GET_COMMITTEE_TYPES:
			return {
				...state,
				committeeTypes: action.payload
            };
        case GET_PARENT_COMMITTEES:
			return {
				...state,
				parentCommittees: action.payload
			};
		case UPDATE_COMMITTEE:
			return {
				...state,
				committees: action.payload
			};
		case ADD_COMMITTEE_DOCUMENTS:
			return {
				...state,
				committeeDocuments: action.payload
			};
		case GET_COMMITTEE_DOCUMENTS:
			return {
				...state,
				committeeDocuments: action.payload
			};
		case DELETE_COMMITTEE_DOCUMENT:
				return {
					...state,
					committeeDocuments: action.payload
				};	
		default:
			return state;
	}
};
